import { createApiClient } from '@missions/api-client';
import { tenantLocation } from './tenant';

type Listener = () => void;
const unauthListeners = new Set<Listener>();
/** Subscribe to "refresh failed → signed out" (SessionProvider shows the sign-in screen). */
export function onUnauthenticated(fn: Listener): () => void {
  unauthListeners.add(fn);
  return () => unauthListeners.delete(fn);
}

/**
 * Typed API client for the tenant app (endpoint manifest in @missions/types).
 * Base URL is the same-origin `/api` proxy in production; VITE_API_URL overrides it for local dev.
 */
export const api = createApiClient({
  baseUrl: (import.meta.env.VITE_API_URL ?? '/api').replace(/\/$/, ''),
  refreshKey: 'auth.refresh',
  headers: (): Record<string, string> => {
    const t = tenantLocation();
    const h: Record<string, string> = { 'x-tenant-host': t.host };
    if (t.slug) h['x-tenant-slug'] = t.slug;
    return h;
  },
  onUnauthenticated: () => unauthListeners.forEach((fn) => fn()),
  validateResponses: import.meta.env.DEV,
});
